import * as React from "react";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
import viewDefinitions, { isAsyncComponent } from "./view-definitions";
import createView from "./view-initializer";

export default function serverInitializer() {
    // Expose React, ReactDOM and ReactDOMServer for React.NET
    global.React = React;
    global.ReactDOM = ReactDOM;
    global.ReactDOMServer = ReactDOMServer;

    global.GBK.views = getComponentMap();
}

/**
 * React.NET expects all components to be available on a global object.
 */
function getComponentMap() {
    const views = viewDefinitions();

    return Object.keys(views).reduce<{
        [key: string]: React.ComponentType<any>;
    }>((acc, viewName) => {
        const component = views[viewName].component;

        // `isAsyncComponent` checks if `__SERVER__ === true`, so this should
        // always be truthy! The check is primarily to make TS happy.
        if (!isAsyncComponent(component)) {
            acc[viewName] = createView({
                name: views[viewName].name,
                component: component().default
            });
        }

        return acc;
    }, {});
}
